<template>
    <div></div>
</template>
<script>
    import store from '../store/store'
    import {ebus} from '../vendor/ebus';
    // import * as xhr from '../api/xhr.js'
    // import * as qconst from '../vendor/qconstants';
    import * as util from '../vendor/util'
    import * as firebaseUtil from '../firebase/firebaseUtil'


    export default {
        name: "StempelLogic",
        created() {
            ebus.$on('addStempelToCart', () => {
                this.addStempelToCart();
            });
        },
        methods: {
            addStempelToCart() {
                //this coupon does not exist in the database but will be checked against "stempelkarte" for fuid
                let c = {};
                c.isCoupon = true;
                c.count = 1;
                c.id = 'stempel-' + firebaseUtil.getFuid();
                c.nameToDisplay = 'Stempelkarte';
                c.title = 'Stempelkarte';
                c.text = '';
                c.combinable = false;
                c.validUntil = Date.now() + 99999999;
                c.type = 'amount';
                c.amount = 1 * this.$store.getters.stempelRabattAmount;
                c.visibility = 'private';
                c.applicable = false;
                c.allowMulti = false;
                c.cartItemId = util.generateClientId();
                c.couponCode = c.cartItemId;
                c.forRedeem = true; // Unterscheidung zwischen Gutschein kaufen und Gutschein einlösen
                this.$store.commit('addItemToCart', {item: c});
                // this.$store.commit('wantsToRedeemStempel', true);
            }
        }

    }
</script>


<style scoped>

</style>